export default {"src":"/_next/static/media/icon_earn_calendar.7fdeec91.svg","height":39,"width":31,"blurWidth":0,"blurHeight":0};